import { render } from "./IngressFullPath.vue?vue&type=template&id=e2484cb8"
import script from "./IngressFullPath.vue?vue&type=script&lang=js"
export * from "./IngressFullPath.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../Users/onchainengineer/workbench/sourcecode/github_autonomy-cloud/dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__